import { useMemo } from 'react';
import { ACCOMMODATION_LEG_LOGS } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/consts';
import { ChangeLogResourceItem } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/components/ChangeLogResourceItem';
import { LogisticsChangeLogType, LogisticsResourceType } from '@/api/apis/route';
import { CaseResourceType } from '@/api/apis/case';
import { ChangeLogResources } from './ChangeLogResource';

type ChangeLogResourcesListProps = {
  logType: LogisticsChangeLogType;
  resources: LogisticsResourceType[];
  hasScs?: boolean;
};

export const ChangeLogResourcesList = ({ logType, resources, hasScs }: ChangeLogResourcesListProps) => {
  const csResources = useMemo(
    () => resources.filter((r) => r.resourceType === CaseResourceType.ClinicalSpecialist),
    [resources],
  );
  const rsResources = useMemo(() => resources.filter((r) => r.resourceType === CaseResourceType.Surgeon), [resources]);
  const deviceResources = useMemo(
    () => resources.filter((r) => r.resourceType === CaseResourceType.OCSConsole),
    [resources],
  );

  const crewPilots = useMemo(() => {
    if (ACCOMMODATION_LEG_LOGS.includes(logType)) {
      return resources.filter((r) => r.resourceType === CaseResourceType.Crew);
    }

    return [];
  }, [logType, resources]);

  const mainResources = useMemo(() => {
    return [...csResources, ...rsResources, ...deviceResources];
  }, [csResources, rsResources, deviceResources]);

  if (!mainResources.length && !crewPilots.length && !hasScs) return null;

  return (
    <div className="flex items-center gap-x-3 gap-y-1 flex-wrap">
      {mainResources.map((r) => (
        <ChangeLogResourceItem key={r.resourceId} resource={r} />
      ))}
      {hasScs && <ChangeLogResources type={CaseResourceType.OCSConsole} isScs title="Static Cold Storage" />}
      {crewPilots.map((pilot) => (
        <ChangeLogResourceItem key={pilot.resourceId} resource={pilot} />
      ))}
    </div>
  );
};
